export default __webpack_public_path__ + "static/media/gallery22.3d265b04.jpg";